import React, { useState, useEffect } from 'react';
import { TranslationFunction }  from '../../types';

const classNames = require('classnames');

interface TabItemProps {
    active: boolean;
    label: string;
    idx: number;
    onClick: (index: number) => void;
    unread?: number;
    translate?: TranslationFunction;
}

const TabItem: React.FC<TabItemProps> = ({ translate, active, label, idx, onClick, unread }) => {
    const [unreadCounter, setUnreadCounter] = useState(0);

    const linkClass = classNames({
        tab__item: true,
        tab__active: active,
    });

    const tabId: string = (idx === 0 ? 'inbox' : 'smart_list');
    const formatCounter = num => {
        if (num > 99) {
            return '99+';
        }
        return num;
    };

    useEffect(() => {
        setUnreadCounter(unread);
    }, [unread]);

    return (
        <a className={linkClass} id={tabId} onClick={() => onClick(idx)}>
            {label}
            {tabId === 'inbox' && formatCounter(unreadCounter) ? <span className="tab__counter">{formatCounter(unreadCounter)}</span> : null}
        </a>
    );
};

export default TabItem;



// WEBPACK FOOTER //
// ./src/components/Tabs/TabItem.tsx